// extracted by mini-css-extract-plugin
export var clauseRow = "_d2-6";
export var emptyState = "_d2-d";
export var filterContent = "_d2-a";
export var filterGroup = "_d2-1";
export var filterGroupContainer = "_d2-0";
export var nestedGroup = "_d2-2";
export var nestedGroupContent = "_d2-b";
export var nestedGroupDepth1 = "_d2-3";
export var nestedGroupDepth2 = "_d2-4";
export var nestedGroupDepth3 = "_d2-5";
export var nestedGroupEmpty = "_d2-c";
export var operatorAnd = "_d2-8";
export var operatorOr = "_d2-9";
export var operatorToggle = "_d2-7";
export var removeGroupButton = "_d2-e";